<app-dialog
  [headerLabel]="dialogTitle"
  [hideActions]="true"
  [dialogType]="dialogType"
  [trackingDialogName]="trackingDialogName"
  [trackingScreenName]="trackingScreenName"
>
  <div id="attachment-view-dialog">
    <img [attr.src]="attachment?.fileUrl" class="img-view" />
  </div>
</app-dialog>
